<template>
  <div id="app" class="py-5">

		<ItemizerSteps v-if="this.event" :event="this.event"></ItemizerSteps>

		<div v-if="!this.event">You have not provided a query parameter for the event. Something like http://your-url?event=12345. <br> A sample event is b458b135-45e1-4cf5-951f-d0c72d01339f</div>
  </div>
</template>

<script>
import ItemizerSteps from './components/ItemizerSteps.vue'

export default {
  name: 'App',
  components: {
		ItemizerSteps
  },
  data: function() {
    return {
      event: null
    }
  },
  created: function() {
    // reads the event query parameter from the URL

    const event = new URL(location.href).searchParams.get('event');
    console.log(event);
    this.event = event;
  }
}
</script>
